// const baseUrl = "http://localhost:80"
const baseUrl = "http://devtest-agsift.ap-south-1.elasticbeanstalk.com"; // beta environmen
// const baseUrl = "http://172.16.16.38";
// const baseUrl = "http://dev-agsift.ap-south-1.elasticbeanstalk.com"; // dev environment
// const baseUrl = "https://api.agsift.com"; // ALSUM ENVIRONMENT
// const baseUrl = "http://52.66.28.67"


export default baseUrl;
